import React from 'react';
import { Clock, Euro, MapPin, Star } from 'lucide-react';
import { mockHotelData } from './mock';

const Tours = () => {
  const { tours } = mockHotelData;

  return (
    <section id="tours" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            {tours.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Exploring the beautiful island of Cyprus with unforgettable day trips and adventures
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {tours.tours.map((tour, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 overflow-hidden"
            >
              {/* Tour Image */}
              <div className="relative h-64">
                <img
                  src={tour.image}
                  alt={tour.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-2xl font-bold text-white mb-2">{tour.name}</h3>
                </div>
              </div>

              {/* Tour Content */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2 text-gray-600">
                    <Clock size={18} />
                    <span className="font-medium">{tour.duration}</span>
                  </div>
                  <div className="flex items-center gap-2 text-green-600">
                    <Euro size={18} />
                    <span className="font-bold">{tour.price}</span>
                  </div>
                </div>

                <p className="text-gray-600 mb-6">{tour.description}</p>

                {/* Tour Highlights */}
                <div>
                  <h4 className="font-bold text-gray-800 mb-3">Highlights</h4>
                  <div className="space-y-2">
                    {tour.highlights.map((highlight, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <Star className="text-yellow-500 fill-current" size={16} />
                        <span className="text-sm text-gray-600">{highlight}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Book Button */}
                <button className="w-full mt-6 bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-medium transition-colors duration-200">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Tour Tips */}
        <div className="mt-16 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-8">
          <h3 className="text-3xl font-bold text-gray-800 mb-6 text-center">Our Tour Tips</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="flex items-start gap-4">
              <MapPin className="text-blue-500 mt-1" size={20} />
              <div>
                <h4 className="font-bold text-gray-800 mb-2">Book Early</h4>
                <p className="text-gray-600 text-sm">Popular tours fill up quickly, especially during peak season</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Clock className="text-green-500 mt-1" size={20} />
              <div>
                <h4 className="font-bold text-gray-800 mb-2">Start Early</h4>
                <p className="text-gray-600 text-sm">Morning tours avoid crowds and afternoon heat</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Euro className="text-purple-500 mt-1" size={20} />
              <div>
                <h4 className="font-bold text-gray-800 mb-2">Bring Cash</h4>
                <p className="text-gray-600 text-sm">Some local vendors prefer cash for souvenirs and snacks</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tours;